<img *ngIf="checked" alt="checkmark" src="assets/icons/checkmark_white.svg">
